import { DEFAULT_LOCALE, INTERFACE_LOCALES, UserLocale } from '../config';

// 'en' was persisted in localStorage before the interface locale codes were
// aligned with the platform ones ('en-US').
const LEGACY_LOCALE_ALIASES: Record<string, UserLocale> = {
  en: 'en-US',
};

export const normalizeInterfaceLocale = (
  locale?: string | null,
): UserLocale => {
  if (!locale) {
    return DEFAULT_LOCALE;
  }

  const alias = LEGACY_LOCALE_ALIASES[locale];

  if (alias) {
    return alias;
  }

  return INTERFACE_LOCALES.includes(locale as UserLocale)
    ? (locale as UserLocale)
    : DEFAULT_LOCALE;
};
